<template>
  <div class="wrapper">
    <div class="main">
      <div class="section special-first-section-top">
        <div class="container text-center">
          <h1 class="title">
            {{ $t("home.title1") }}<br />
            {{ $t("home.title2") }}
          </h1>
        </div>

        <div
          class="home-projects-section"
          :class="{ 'english-home-projects-section': !isCN }"
        >
          <div :class="isMobileDevice ? 'container' : 'home-container'">
            <div class="md-layout">
              <div
                v-if="isCN && !isMobileDevice"
                class="md-layout-item md-size-100 md-small-size-100 grid-item-speical"
                @mouseover="isHoverLume = true"
                @mouseout="isHoverLume = false"
              >
                <router-link
                  class="lume-home-link"
                  :to="`/${$i18n.locale}/lume`"
                >
                  <div
                    class="lume-home-card"
                    :class="{ 'lume-home-card-hover': isHoverLume }"
                  >
                    <div>
                      <img class="lume-home-icon" :src="lume_icon" />
                      <p>{{ $t("footer.lume") }}</p>
                      <h2>{{ $t("lume.home_tile.title") }}</h2>
                    </div>
                    <img class="lume-home-spirits" :src="lume_spirits" />
                  </div>
                </router-link>
              </div>
              <div
                v-else-if="isCN"
                class="md-layout-item md-size-100 md-small-size-100 grid-item-speical-mobile"
              >
                <router-link
                  class="lume-home-link"
                  :to="`/${$i18n.locale}/lume`"
                >
                  <div class="lume-home-card lume-home-card-mobile">
                    <div>
                      <img class="lume-home-icon" :src="lume_icon" />
                      <p>{{ $t("footer.lume") }}</p>
                      <h2>{{ $t("lume.home_tile.title") }}</h2>
                    </div>
                    <img class="lume-home-spirits" :src="lume_spirits" />
                  </div>
                </router-link>
              </div>

              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-100 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverYoyolumi = true"
                @mouseout="isHoverYoyolumi = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/yoyolumi`">
                  <img v-show="isHoverYoyolumi" :src="yoyolumi_cn_hover" />
                  <img v-show="!isHoverYoyolumi" :src="yoyolumi_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/yoyolumi`">
                  <img v-show="isHoverYoyolumi" :src="yoyolumi_hover" />
                  <img v-show="!isHoverYoyolumi" :src="yoyolumi" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-100 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverYoyolumi = true"
                @mouseout="isHoverYoyolumi = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/yoyolumi`">
                  <img :src="yoyolumi_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/yoyolumi`">
                  <img :src="yoyolumi_hover" />
                </router-link>
              </div>

              <div
                v-if="!isCN && !isMobileDevice"
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverLume = true"
                @mouseout="isHoverLume = false"
              >
                <a
                  href="https://apps.apple.com/ca/app/lume-your-body-speaks/id6759819851"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img v-show="isHoverLume" :src="lume_hover" />
                  <img v-show="!isHoverLume" :src="lume" />
                </a>
              </div>
              <div
                v-else-if="!isCN"
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverLume = true"
                @mouseout="isHoverLume = false"
              >
                <a
                  href="https://apps.apple.com/ca/app/lume-your-body-speaks/id6759819851"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img :src="lume_hover" />
                </a>
              </div>

              <div
                v-if="!isMobileDevice"
                :class="[
                  'md-layout-item md-small-size-100 grid-item-speical desktop-img-fill-in',
                  isCN ? 'md-size-100' : 'md-size-50'
                ]"
                @mouseover="isHoverDiscovery = true"
                @mouseout="isHoverDiscovery = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/discovery`">
                  <img v-show="isHoverDiscovery" :src="discovery_cn_hover" />
                  <img v-show="!isHoverDiscovery" :src="discovery_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/discovery`">
                  <img v-show="isHoverDiscovery" :src="discovery_hover" />
                  <img v-show="!isHoverDiscovery" :src="discovery" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-100 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverDiscovery = true"
                @mouseout="isHoverDiscovery = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/discovery`">
                  <img :src="discovery_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/discovery`">
                  <img :src="discovery_hover" />
                </router-link>
              </div>

              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverAvatar = true"
                @mouseout="isHoverAvatar = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/avatar`">
                  <img v-show="isHoverAvatar" :src="avatar_cn_hover" />
                  <img v-show="!isHoverAvatar" :src="avatar_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/avatar`">
                  <img v-show="isHoverAvatar" :src="avatar_hover" />
                  <img v-show="!isHoverAvatar" :src="avatar" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverAvatar = true"
                @mouseout="isHoverAvatar = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/avatar`">
                  <img :src="avatar_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/avatar`">
                  <img :src="avatar_hover" />
                </router-link>
              </div>

              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverSystem = true"
                @mouseout="isHoverSystem = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/system`">
                  <img v-show="isHoverSystem" :src="system_cn_hover" />
                  <img v-show="!isHoverSystem" :src="system_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/system`">
                  <img v-show="isHoverSystem" :src="system_hover" />
                  <img v-show="!isHoverSystem" :src="system" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverSystem = true"
                @mouseout="isHoverSystem = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/system`">
                  <img :src="system_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/system`">
                  <img :src="system_hover" />
                </router-link>
              </div>

              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverConcert = true"
                @mouseout="isHoverConcert = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/concert`">
                  <img v-show="isHoverConcert" :src="concert_cn_hover" />
                  <img v-show="!isHoverConcert" :src="concert_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/concert`">
                  <img v-show="isHoverConcert" :src="concert_hover" />
                  <img v-show="!isHoverConcert" :src="concert" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverConcert = true"
                @mouseout="isHoverConcert = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/concert`">
                  <img :src="concert_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/concert`">
                  <img :src="concert_hover" />
                </router-link>
              </div>

              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverSFDW = true"
                @mouseout="isHoverSFDW = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/sfdw`">
                  <img v-show="isHoverSFDW" :src="sfdw_cn_hover" />
                  <img v-show="!isHoverSFDW" :src="sfdw_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/sfdw`">
                  <img v-show="isHoverSFDW" :src="sfdw_hover" />
                  <img v-show="!isHoverSFDW" :src="sfdw" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverSFDW = true"
                @mouseout="isHoverSFDW = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/sfdw`">
                  <img :src="sfdw_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/sfdw`">
                  <img :src="sfdw_hover" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "home",
  bodyClass: "home-page",
  props: {
    yoyolumi: {
      type: String,
      default: require("@/assets/img/home/yoyolumi.png")
    },
    discovery: {
      type: String,
      default: require("@/assets/img/home/discovery.png")
    },
    avatar: {
      type: String,
      default: require("@/assets/img/home/avatar.png")
    },
    system: {
      type: String,
      default: require("@/assets/img/home/system.png")
    },
    concert: {
      type: String,
      default: require("@/assets/img/home/concert.png")
    },
    sfdw: {
      type: String,
      default: require("@/assets/img/home/sfdw.png")
    },
    lume_icon: {
      type: String,
      default: require("@/assets/img/lume/icon.png")
    },
    lume_spirits: {
      type: String,
      default: require("@/assets/img/lume/lounge_spirits_group.png")
    },
    lume: {
      type: String,
      default: require("@/assets/img/home/lume.png")
    },
    lume_hover: {
      type: String,
      default: require("@/assets/img/home/lume_hover.png")
    },
    yoyolumi_hover: {
      type: String,
      default: require("@/assets/img/home/yoyolumi_hover.png")
    },
    discovery_hover: {
      type: String,
      default: require("@/assets/img/home/discovery_hover.png")
    },
    avatar_hover: {
      type: String,
      default: require("@/assets/img/home/avatar_hover.png")
    },
    system_hover: {
      type: String,
      default: require("@/assets/img/home/system_hover.png")
    },
    concert_hover: {
      type: String,
      default: require("@/assets/img/home/concert_hover.png")
    },
    sfdw_hover: {
      type: String,
      default: require("@/assets/img/home/sfdw_hover.png")
    },
    discovery_cn: {
      type: String,
      default: require("@/assets/img/home/discovery_cn.png")
    },
    avatar_cn: {
      type: String,
      default: require("@/assets/img/home/avatar_cn.png")
    },
    system_cn: {
      type: String,
      default: require("@/assets/img/home/system_cn.png")
    },
    concert_cn: {
      type: String,
      default: require("@/assets/img/home/concert_cn.png")
    },
    sfdw_cn: {
      type: String,
      default: require("@/assets/img/home/sfdw_cn.png")
    },
    yoyolumi_cn: {
      type: String,
      default: require("@/assets/img/home/yoyolumi.png")
    },
    discovery_cn_hover: {
      type: String,
      default: require("@/assets/img/home/discovery_cn_hover.png")
    },
    avatar_cn_hover: {
      type: String,
      default: require("@/assets/img/home/avatar_cn_hover.png")
    },
    system_cn_hover: {
      type: String,
      default: require("@/assets/img/home/system_cn_hover.png")
    },
    concert_cn_hover: {
      type: String,
      default: require("@/assets/img/home/concert_cn_hover.png")
    },
    sfdw_cn_hover: {
      type: String,
      default: require("@/assets/img/home/sfdw_cn_hover.png")
    },
    yoyolumi_cn_hover: {
      type: String,
      default: require("@/assets/img/home/yoyolumi_hover.png")
    }
  },
  data() {
    return {
      isMobileDevice: this.$isMobile,
      isCN: false,
      isHoverLume: false,
      isHoverYoyolumi: false,
      isHoverDiscovery: false,
      isHoverAvatar: false,
      isHoverSystem: false,
      isHoverConcert: false,
      isHoverSFDW: false
    };
  },
  watch: {
    "$route.path": {
      handler: function(path) {
        if (path.includes("en")) {
          this.isCN = false;
        } else {
          this.isCN = true;
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-item-speical {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  padding-left: 10px;
  cursor: pointer;
}
.grid-item-speical-mobile {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 0px !important;
  padding-left: 0px !important;
  cursor: pointer;
}
.home-container,
.home-container-fluid {
  max-width: 1440px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;

  .section & {
    flex-direction: column;
  }
}
.home-projects-section {
  padding-top: 15% !important;
}
.lume-home-card {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 440px;
  padding: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #7aa5ff 0%, #f3d6ee 62%, #fff2af 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  overflow: hidden;
  transition: transform 0.24s ease, box-shadow 0.24s ease;

  > div {
    flex: 1 1 auto;
    min-width: 0;
  }

  p {
    margin-bottom: 12px;
    color: #ffffff;
    font-size: 1.1rem;
    font-weight: 700;
  }

  h2 {
    max-width: 620px;
    color: #ffffff;
    font-size: 3.4rem;
    line-height: 1.18;
    text-shadow: 0 12px 30px rgba(91, 112, 184, 0.28);
  }
}
.lume-home-link {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  text-decoration: none !important;
}
.lume-home-card-hover {
  transform: translateY(-4px);
  box-shadow: 0 28px 80px rgba(109, 134, 203, 0.22);
}
.lume-home-icon {
  width: 96px !important;
  min-width: 96px !important;
  height: 96px !important;
  min-height: 96px !important;
  border-radius: 22px;
  margin-bottom: 24px;
}
.lume-home-spirits {
  flex: 0 1 44%;
  width: 44% !important;
  min-width: 280px !important;
  max-width: 560px;
  height: auto !important;
  min-height: auto !important;
  align-self: flex-end;
}
.lume-home-card-mobile {
  min-height: 520px;
  padding: 30px;
  flex-direction: column;
  align-items: flex-start;

  h2 {
    font-size: 2.2rem;
  }

  .lume-home-spirits {
    width: 100% !important;
    min-width: 0 !important;
  }
}
@media (max-width: 1100px) {
  .lume-home-card {
    padding: 36px;

    h2 {
      font-size: 2.8rem;
    }
  }
}
@media (max-width: 768px) {
  .lume-home-card {
    min-height: 520px;
    padding: 30px;
    flex-direction: column;
    align-items: flex-start;

    h2 {
      font-size: 2.2rem;
    }
  }

  .lume-home-spirits {
    width: 100% !important;
    min-width: 0 !important;
  }
}
.desktop-img-fill-in {
  img {
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
  }
}
</style>
